import { useEffect } from 'react';
import { getGladOsOrigin } from 'src/presentation/components/pages/helpers';

export type MessageTypes = (typeof MessageTypes)[number];
const MessageTypes = [
  'addActionAdapter',
  'edit',
  'resize',
  'returnToAppAction',
  'viewLogs',
  'editReplace',
  'importFinished',
  'showActiveInactiveDialog',
  'showGuidesDialog',
  'showDuplicatedDialog',
  'updateActionAdapter',
  'duplicateActionAdapter',
  'actionAdapterUpdated',
  'actionAdapterDuplicated',
  'actionAdapterFailedToUpdate',
  'openActionAdapterRuns',
] as const;

export const useListenMessage = (messageTypes: MessageTypes[], onMessage: (event: MessageEvent) => void) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== getGladOsOrigin(window.location.origin)) {
        return;
      }

      if (!messageTypes) {
        return;
      }
      if (!messageTypes.includes(event.data.type)) {
        return;
      }
      onMessage(event);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [messageTypes, onMessage]);
};

export const postMessageToIframe = (iframe: HTMLIFrameElement, messageType: MessageTypes, value?: unknown) => {
  if (!iframe.contentWindow) {
    return;
  }

  iframe.contentWindow?.postMessage(
    {
      type: messageType,
      ...(typeof value === 'object' ? value : {}),
    },
    '*'
  );
};
